module.exports = __webpack_public_path__ + "static/img/status_bg.3be50dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share/order/status_bg.png
// module id = 5Xxn
// module chunks = 16